/**
 *
 * AccountModal
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { useSignOut } from 'containers/User';
import messages from './messages';
import ModalContent from './ModalContent';

function AccountModal(props) {
  const { onHide, param } = props;
  const [accountDeleted, setAccountDeleted] = React.useState(false);
  const signOut = useSignOut();

  function handleDeleteSuccess() {
    setAccountDeleted(true);
    signOut();
  }

  function handleClose() {
    setAccountDeleted(false);
    onHide();
  }

  return (
    <Modal show onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...messages.header} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ModalContent
          param={param}
          accountDeleted={accountDeleted}
          onDeleteSuccess={handleDeleteSuccess}
        />
      </Modal.Body>
    </Modal>
  );
}

AccountModal.propTypes = {
  param: PropTypes.string,
  onHide: PropTypes.func.isRequired,
};

export default AccountModal;
